import Icon from '../components/Icon.vue'

Icon.register({
  'first-aid': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M0 80c0-26.5 21.5-48 48-48h48v448h-48c-26.5 0-48-21.5-48-48v-352zM128 480v-448h320v448h-320zM192 232v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8zM528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-48v-448h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/first-aid.js
// module id = 1355
// module chunks = 0